// extracted by mini-css-extract-plugin
module.exports = {"bg":"e_vp","border":"e_wp"};